import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
request.get('/api/table/crmedical/custom/table/list', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api/table/crmedical/custom/table/detail', Object.assign({}, options, { params }))

export const remove = (params, options) =>
request.post('/api/table/crmedical/custom/table/remove', qs.stringify(params),options);

export const add = (params, options) =>
request.post('/api/table/crmedical/custom/table/submit', params,options)

export const update = (params, options) =>
request.post('/api/table/crmedical/custom/table/submit', params,options)
